import {Component, Input, ViewEncapsulation, EventEmitter, Output, OnDestroy, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {GlobalSubscriptionDialogComponent} from '../global-subscripton-dialog/global-subscripton-dialog.component';
import {LoaderService} from '../../../services/infrastructure/loader.service';
import {Subscription} from 'rxjs';
import {SubscriptionManagementService} from '../../../services/subscription-management/subscription-management.service';
const _ = require('lodash');
import * as $ from 'jquery';

@Component({
  selector: 'app-my-subscriptions-component',
  templateUrl: './my-subscriptions-component.component.html',
  styleUrls: ['./my-subscriptions-component.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class MySubscriptionsComponentComponent implements OnDestroy, OnChanges {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('mySubscriptionTable', { read: MatSort }) mySubscriptionTableSort: MatSort;
  @ViewChild('mySubscriptionTableByAccount', { read: MatSort }) mySubscriptionTableByAccountSort: MatSort;

  subscription = new Subscription();
  groupByUserIdDS: MatTableDataSource<any>;
  groupByAccountsDS: MatTableDataSource<any>;
  mySubscriptionSort: MatSort;
  groupByUserIdColumns: string[] = ['users', 'userName', 'userID', 'emailAddress', 'userRole'];
  groupByAccountsColumns: string[] = ['accounts', 'accountNumber', 'accountName', 'address', 'city', 'state'];
  isTopLevelCheckboxClicked = false;
  parentRowUserId: string;
  canShowGlobalSub = false;
  @Input() groupBy: string;
  @Input() isPushPinClicked = false;
  @Output() SubscribeOutput = new EventEmitter<any>();
  @Output() SetGlobalSubscriptionData = new EventEmitter<any>();
  @Output() GlobalSubscriptionClick = new EventEmitter<any>();
  @Output() pushPinClick = new EventEmitter<any>();
  @Input() selectedTab: string;
  // set and get input field for header
  @Input()
  set userIdGridDS(data: any) {
    this.isTopLevelCheckboxClicked = false;
    if (data && data.length >= 0) {
      this.groupByUserIdDS = new MatTableDataSource(data);
      this.groupByUserIdDS.sort = this.mySubscriptionTableSort;
      this.canShowGlobalSub = data.length > 0 && data[0].mySubscriptionAccountsVM.length > 0;
    }
  }

  get userIdGridDS(): any {
    return this.groupByUserIdDS;
  }

  @Input()
  set accountsGridDS(data: any) {
    this.isTopLevelCheckboxClicked = false;
    if (data && data.length >= 0) {
      this.groupByAccountsDS = new MatTableDataSource(data);
      this.groupByAccountsDS.sort = this.mySubscriptionTableByAccountSort;
    }
  }

  get accountsGridDS(): any {
    return this.groupByAccountsDS;
  }

  constructor(
    public dialog: MatDialog,
    private loaderService: LoaderService,
    private subscriptionManagementService: SubscriptionManagementService,) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.groupBy || changes.selectedTab) {
      this.isTopLevelCheckboxClicked = false;
      setTimeout(x => {
        if (this.groupByUserIdDS.data?.length > 0 && this.mySubscriptionTableSort)
          this.groupByUserIdDS.sort = this.mySubscriptionTableSort;
        if (this.groupByAccountsDS.data?.length > 0 && this.mySubscriptionTableByAccountSort)
          this.groupByAccountsDS.sort = this.mySubscriptionTableByAccountSort;
      }, 500);

    }
  }

  onHover(data: string) {
    this.parentRowUserId = data;
  }

  onPushPinClick(data: any): void {
    const status = !data.isPushPinClicked;
    if (this.groupBy == 'userId') {
      if (this.groupByUserIdDS && this.groupByUserIdDS.data.length > 0) {
        this.groupByUserIdDS.data.map((item) => {
          item.isPushPinClicked = false;
        });
      }
    }
    if (this.groupBy == 'accounts') {
      if (this.groupByAccountsDS && this.groupByAccountsDS.data.length > 0) {
        this.groupByAccountsDS.data.map((item) => {
          item.isPushPinClicked = false;
        });
      }
    }
    data.isPushPinClicked = status;
    if (data.isPushPinClicked) {
      $('.tableContainer').css('overflow', 'hidden');
    }
    else {
      $('.tableContainer').css('overflow', '');
    }
  }

  openGlobalSubscriptionDialog(): void {
    if (this.canShowGlobalSub) {
      let userRoleList = [];
      if (this.groupBy == 'userId') {
        userRoleList.push(this.groupByUserIdDS.data[0].userRole);
        // this.groupByUserIdDS.data.map((user) => {
        //  const account = user.mySubscriptionAccountsVM.find((account) => {
        //                    return account.isChecked
        //  })
        //  if (account) {
        //    userRoleList.push(user.userRole);
        //  }
        // })
      }
      if (this.groupBy == 'accounts') {
        userRoleList.push(this.groupByAccountsDS.data[0].mySubscriptionAccountUserVM[0].userRole);
        // this.groupByAccountsDS.data.map((accounts) => {
        //  accounts.mySubscriptionAccountUserVM.map((users) => {
        //    if (users.isChecked) {
        //      userRoleList.push(users.userRole);
        //    }
        //  })
        // })
      }

      userRoleList = [...new Set(userRoleList)];
      this.loaderService.setLoaderStatus(true);
      this.subscription.add(this.subscriptionManagementService.getSubscriptionsList(userRoleList).subscribe((result: any) => {
        if (result.length == 0) {
          result.push({
            isFavouriteChecked: false
          })
        }
        else {
          result[0].isFavouriteChecked = false;
        }
        const dialogRef = this.dialog.open(GlobalSubscriptionDialogComponent, {
          width: '1200px',
          data: { subscriptionList: result, dialogType: 'globalLevel', selectedIndex: 0, isFavouriteOptionAvailable: this.groupByUserIdDS.data[0].mySubscriptionAccountsVM[0].isFavouriteOptionAvailable, isFavouriteChecked: false },
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.GlobalSubscriptionClick.emit(result);
            this.isTopLevelCheckboxClicked = false;
          }
        });
        this.loaderService.setLoaderStatus(false);
      },
        (error) => {
          this.loaderService.setLoaderStatus(false);
        }
      )
      );
    }
  }

  toggleFirstLevelRow(element: { isFirstLevelExpanded: boolean; isPushPinClicked: boolean; }) {
    let status = false;
    element.isFirstLevelExpanded = !element.isFirstLevelExpanded;
    element.isPushPinClicked = false;
    if (this.groupBy == 'userId') {
      if (this.groupByUserIdDS && this.groupByUserIdDS.data.length > 0) {
        status = this.groupByUserIdDS.data.every(t => !t.isFirstLevelExpanded || !t.isPushPinClicked);
      }
    }
    if (this.groupBy == 'accounts') {
      if (this.groupByAccountsDS && this.groupByAccountsDS.data.length > 0) {
        status = this.groupByAccountsDS.data.every(t => !t.isFirstLevelExpanded || !t.isPushPinClicked);
      }
    }
    if (status) {
      $('.tableContainer').css('overflow', '');
    }
  }

  EditSubscriptions(account: any, user: any) {
    const filter = {
      AccountNumber: account.accountNumber,
      UserID: user.userID,
      UserRole: user.userRole
    };
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.subscriptionManagementService.getSubscriptionForAccount(filter).subscribe((result: any) => {
      const dialogRef = this.dialog.open(GlobalSubscriptionDialogComponent, {
        width: '1200px',
        data: { subscriptionList: result, dialogType: 'accountLevel', selectedIndex: 0, isFavouriteOptionAvailable: this.groupByUserIdDS.data[0].mySubscriptionAccountsVM[0].isFavouriteOptionAvailable, isFavouriteChecked: result.subscriptionList.isFavouriteChecked },
      });

      this.subscription.add(dialogRef.afterClosed().subscribe(result => {
        if (result) {
          const data = [];
          result.subscriptionList.map((item) => {
            data.push({
              'isActive': item.isServerSideChecked, 'subscriptionTypeID': item.subscriptionTypeID, 'accountNumber': result.accountNumber, 'userID': result.userID, 'isFavouriteChecked': result.isFavouriteChecked, 'isStopLightChecked': item.isStopLightChecked, 'subscriptionSuplementId': item.subscriptionSuplementId
 ,tabIndex: 0 });
          });
          this.SubscribeOutput.emit(data);
        }
      }));
      this.loaderService.setLoaderStatus(false);
    },
      (error) => {
        this.loaderService.setLoaderStatus(false);
      }
    )
    );
  }

  showHideGlobalSubscription(): boolean {
    let status = false;
    if (this.groupBy == 'userId') {
      if (this.groupByUserIdDS && this.groupByUserIdDS.data.length > 0) {
        this.groupByUserIdDS.data.map((item) => {
          if (item.isChecked) {
            status = true;
          }
          item.mySubscriptionAccountsVM.map((accounts) => {
            if (accounts.isChecked) {
              status = true;
            }
          });
        });
      }
    }
    if (this.groupBy == 'accounts') {
      if (this.groupByAccountsDS && this.groupByAccountsDS.data.length > 0) {
        this.groupByAccountsDS.data.map((item) => {
          if (item.isChecked) {
            status = true;
          }
          item.mySubscriptionAccountUserVM.map((users) => {
            if (users.isChecked) {
              status = true;
            }
          });
        });
      }
    }
    return status;
  }

  anyLevelChecked(): boolean {
    let status = false;
    if (this.groupBy == 'userId') {
      if (this.groupByUserIdDS && this.groupByUserIdDS.data.length > 0) {
        this.groupByUserIdDS.data.map((item) => {
          if (item.isChecked && !this.isTopLevelCheckboxClicked) {
            status = true;
          }
          item.mySubscriptionAccountsVM.map((accounts) => {
            if (accounts.isChecked && !this.isTopLevelCheckboxClicked) {
              status = true;
            }
          });
        });
      }
    }
    if (this.groupBy == 'accounts') {
      if (this.groupByAccountsDS && this.groupByAccountsDS.data.length > 0) {
        this.groupByAccountsDS.data.map((item) => {
          if (item.isChecked && !this.isTopLevelCheckboxClicked) {
            status = true;
          }
          item.mySubscriptionAccountUserVM.map((users) => {
            if (users.isChecked && !this.isTopLevelCheckboxClicked) {
              status = true;
            }
          });
        });
      }
    }
    return status;
  }

  someFirstLevelComplete(data: any) {
    let status = false;
    if (this.groupBy == 'userId') {
      data.mySubscriptionAccountsVM.map((accounts) => {
        if (accounts.isChecked && !data.isChecked) {
          status = true;
        }
      });
    }
    if (this.groupBy == 'accounts') {
      data.mySubscriptionAccountUserVM.map((user) => {
        if (user.isChecked && !data.isChecked) {
          status = true;
        }
      });
    }
    return status;
  }

  selectAllLevels(status: boolean) {
    this.isTopLevelCheckboxClicked = status;
    if (this.groupBy == 'userId') {
      if (this.groupByUserIdDS.data) {
        this.groupByUserIdDS.data.map((item) => {
          item.isFirstLevelExpanded = item.isPushPinClicked ? true : true;
          item.isChecked = status;
          item.mySubscriptionAccountsVM.map((accounts) => {
            accounts.isChecked = status;
            this.setGlobalSubscriptionData(accounts.accountNumber, item.userID, status);
          });
        });
      }
    }
    if (this.groupBy == 'accounts') {
      if (this.groupByAccountsDS.data) {
        this.groupByAccountsDS.data.map((item) => {
          item.isFirstLevelExpanded = item.isPushPinClicked ? true : true;
          item.isChecked = status;
          item.mySubscriptionAccountUserVM.map((users) => {
            users.isChecked = status;
            this.setGlobalSubscriptionData(item.accountNumber, users.userID, status);
          });
        });
      }
    }
  }

  onCheckboxChange(status: boolean, element: any) {
    if (this.groupBy == 'userId') {
      element.isFirstLevelExpanded = element.isPushPinClicked ? true : status;
      element.isChecked = status;
      element.mySubscriptionAccountsVM.map((accounts) => {
        accounts.isChecked = status;
        this.setGlobalSubscriptionData(accounts.accountNumber, element.userID, status);
      });
      this.isTopLevelCheckboxClicked = this.groupByUserIdDS.data.every(t => t.isChecked);
    }
    if (this.groupBy == 'accounts') {
      element.isFirstLevelExpanded = element.isPushPinClicked ? true : status;
      element.isChecked = status;
      element.mySubscriptionAccountUserVM.map((users) => {
        users.isChecked = status;
        this.setGlobalSubscriptionData(element.accountNumber, users.userID, status);
      });
      this.isTopLevelCheckboxClicked = this.groupByAccountsDS.data.every(t => t.isChecked);
    }
  }

  onSecondLevelCheckboxChange(status: boolean, element: any, userIds: any) {
    if (this.groupBy == 'userId') {
      element.isChecked = status;
      this.setGlobalSubscriptionData(element.accountNumber, userIds.userID, status);
      userIds.isChecked = userIds.mySubscriptionAccountsVM.every(t => t.isChecked);
      this.isTopLevelCheckboxClicked = this.groupByUserIdDS.data.every(t => t.isChecked);
    }
    if (this.groupBy == 'accounts') {
      userIds.isChecked = status;
      this.setGlobalSubscriptionData(element.accountNumber, userIds.userID, status);
      element.isChecked = element.mySubscriptionAccountUserVM.every(t => t.isChecked);
      this.isTopLevelCheckboxClicked = this.groupByAccountsDS.data.every(t => t.isChecked);
    }
  }

  setGlobalSubscriptionData(accountNumber: string, userID: string, status: boolean) {
    const data: any = {};
    data['userID'] = userID;
    data['accountNumber'] = accountNumber;
    data['isSelected'] = status;
    this.SetGlobalSubscriptionData.emit(data);
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
